import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
import { ROUTES } from "core/links";

const FooterInnerNav = (props) => {
    return (
        
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="12">
              <Nav className="nav-footer justify-content-center">
                <NavItem className="text-sm text-3572EF">
                  <NavLink href={ROUTES.FAQ} target="_blank">
                    FAQ
                  </NavLink>
                </NavItem>
                <NavItem className="text-sm text-3572EF">
                  <NavLink href={ROUTES.USER_GUIDE} target="_blank">
                    User Guide
                  </NavLink>
                </NavItem>
                <NavItem className="text-sm text-3572EF">
                  <NavLink href={ROUTES.FEEDBACK} target="_blank">
                    Feedback
                  </NavLink>
                </NavItem>                
              </Nav>
            </Col>
          </Row>
          </Container>
    );
};

export default FooterInnerNav;